module.exports = __webpack_public_path__ + "img/WP23-volunteers1.c31e0d61.jpg";